module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAS1BMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB9CA8ohAAAAGHRSTlMAIuH36smbiVcMCOIo0TAYnJnQQxpAPhcFmDUiAAAA10lEQVQ4y4VTWxKDIAwMDxEERa1tc/+TtlUmNSCyPzDshg0hgT+cXTqtlO4W66CEMAoJyoiMHvpEk6QfWPiKBdbTJZPGC+iJ4onPFCL5r1jBeOTRYxX9bqDqAvUzMXiDGcDRBY/gj42fnnSFA0vqAMLvvIBAh/bkIMWu8N9F0qGBDplCch470MgU28Z41MAeKSPAW7KHloLIBblFjJlFkaTMkzScpyXBsEIdhGSFYqVOgTK8TqWGufFZze9uNwwMY73lWk3bbHuCuHAZRWv0bod3pvDm+H8AhB9AqIpUe/kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/del.png
// module id = dM38
// module chunks = 1